export const Top20Companies = [
  "All",
  "Amazon",
  "IBM",
  "Accenture",
  "Infosys",
  "TCS",
  "Capgemini",
  "Deloitte",
  "PwC",
  "EY",
  "Wipro",
  "Cognizant",
  "Tech Mahindra",
  "Cisco",
  "Goldman Sachs",
  "SAP",
  "Genpact",
  "Virtusa",
  "LTIMindtree",
  "New Relic",
  "S&P Global",
];

export const companiesReferrals = [
  {
    name: "TCS",
    logo: "https://pbs.twimg.com/ext_tw_video_thumb/1837169239180070915/pu/img/fLp35Uu32o3N0CjG.jpg:large",
    careersLink: "https://www.tcs.com/careers",
    url: "https://lnkd.in/gmZViiUD",
  },
  {
    name: "Infosys",
    logo: "https://i.pinimg.com/736x/89/0c/25/890c250fe129488a586b1a99e8b68107.jpg",
    careersLink: "https://www.infosys.com/careers.html",
    url: "https://lnkd.in/gmZViiUD",
  },
  {
    name: "Accenture",
    logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSt4Oc4WBgxZ0KbEjfm1W067bK4yUEAntn3bw&s",
    careersLink: "https://www.accenture.com/in-en/careers/jobsearch",
    url: "https://lnkd.in/dqffdtyM",
  },
  {
    name: "Capgemini",
    logo: "https://download.logo.wine/logo/Capgemini/Capgemini-Logo.wine.png",
    careersLink: "https://www.capgemini.com/in-en/careers/",
    url: "https://linkedin.com/in/pradeep-thombre",
  },
  {
    name: "Deloitte",
    logo: "https://mma.prnewswire.com/media/2441415/Deloitte_Logo.jpg?p=facebook",
    careersLink: "https://www.deloitte.com/in/en/careers.html",
    url: "https://lnkd.in/gWFYceYh",
  },
  // {
  //   name: "Wipro",
  //   logo: "https://www.wipro.com/content/dam/nexus/images/header/wipro-logo.jpg",
  //   careersLink:
  //     "https://careers.wipro.com/content/Experienced-Professionals/?locale=en_US",
  //   email: "wipro.referrals@example.com",
  // },
  // {
  //   name: "Tech Mahindra",
  //   logo: "https://insights.techmahindra.com/styles/text_and_image_desktop/s3/images/logo_wgraypng.png.webp",
  //   careersLink: "https://careers.techmahindra.com/",
  //   email: "techm.referrals@example.com",
  // },
  {
    name: "LTI Mindtree",
    logo: "https://s3.ap-southeast-1.amazonaws.com/images.deccanchronicle.com/dc-Cover-2dc4k4pgb0krmn6kdemp6tvac6-20221115133945.Medi.jpeg",
    careersLink: "https://www.ltimindtree.com/careers/",
    url: "https://ltimindtree.ripplehire.com/candidate/?token=QX2xK27HwH5zb9pCmqiP&lang=en#list",
  },
];

export const preferenceSteps = [
  {
    title: "Select Job Type",
    options: ["All", "Jobs", "Internship", "Referral"],
    type: "multi",
    allOption: "All",
    field: "jobType",
  },
  {
    title: "Select Experience Level",
    options: [
      "All",
      "Freshers",
      "0-2 years",
      "0-3 years",
      "3-5 years",
      "2-5 years",
      "5-7 years",
      "7+ years",
    ],
    type: "multi",
    allOption: "All",
    field: "experienceLevel",
  },
  {
    title: "Preferred Location",
    options: [
      "Pan India",
      "Bengaluru",
      "Hyderabad",
      "Pune",
      "Chennai",
      "Mumbai",
      "Delhi NCR",
      "Noida",
      "Gurugram",
      "Kolkata",
      "Ahmedabad",
      "Jaipur",
      "Chandigarh",
      "Coimbatore",
      "Kochi",
      "Indore",
      "Nagpur",
      "Surat",
      "Mysuru",
      "Thiruvananthapuram",
      "Bhubaneswar",
    ],
    type: "multi",
    allOption: "Pan India",
    field: "location",
  },
  {
    title: "Select Your Skills",
    options: [
      "JavaScript", "React", "Node.js", "Java", "Python", "C++", "Golang", "SQL",
      "MongoDB", "AWS", "Docker", "Kubernetes", "HTML", "CSS", "TypeScript",
    ],
    type: "multi",
    field: "skills",
  },
];
